import { useState, useEffect } from 'react'

// Components
import { Button, Link } from '@tracklib/kit'

// utils
import { safeLocalStorage as localStorage } from 'utils'

import styles from './cookiebar.css'

const CookieBar = (): JSX.Element | null => {
  const [visible, setVisible] = useState(false)
  const cookieConsent = localStorage.getItem('cookieConsent')

  useEffect(() => {
    if (!cookieConsent) {
      setVisible(true)
    }
  }, [cookieConsent])

  if (cookieConsent || !visible) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <span className={styles.text}>
        <span>
          By using Tracklib’s services you agree to our <Link to="/cookies">Cookies Use</Link>. We and our partners operate globally and use
          cookies, including analytics and personalization.
        </span>
      </span>
      <Button
        size="small"
        onClick={(): void => {
          localStorage.setItem('cookieConsent', 'true')
          return setVisible(false)
        }}
        className={styles.button}
      >
        Close
      </Button>
    </div>
  )
}

export default CookieBar
